import "leaflet/dist/leaflet.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

// Early console suppression - before any other code runs
if (process.env.NODE_ENV === 'development') {
  const earlyLog = console.log;
  console.log = function(...args) {
    const message = args.join(' ');
    if (message.includes('[HMR]') || message.includes('Waiting for update signal from WDS')) {
      return;
    }
    earlyLog.apply(console, args);
  };
}

// Suppress development-only console logs
if (process.env.NODE_ENV === 'development') {
  // Also suppress logs that come from webpack's client-side code
  const originalWebpackHotLog = window.__webpack_hot_log__ || (() => {});
  window.__webpack_hot_log__ = () => {}; // Suppress webpack HMR logs
  
  // Suppress webpack hot module logs more aggressively
  if (window.webpackHotUpdate) {
    const originalUpdate = window.webpackHotUpdate;
    window.webpackHotUpdate = function(...args) {
      return originalUpdate.apply(this, args);
    };
  }
  const originalWarn = console.warn;
  const originalLog = console.log;
  const originalInfo = console.info;
  const originalError = console.error;
  
  // Helper function to check if message should be suppressed
  const shouldSuppressMessage = (args) => {
    const message = args.join(' ');
    const messageStr = typeof message === 'string' ? message : String(message);
    
    // Check for specific development debug objects
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null) {
      const obj = args[0];
      if (obj.hasError !== undefined || 
          (typeof obj === 'object' && Object.keys(obj).length < 5)) {
        return true; // Suppress small debug objects
      }
    }
    
    return (
      (messageStr.includes('Critical dependency') && messageStr.includes('geotiff')) ||
      messageStr.includes('[HMR]') ||
      messageStr.includes('Waiting for update signal from WDS') ||
      messageStr.includes('[WDS]') ||
      messageStr.includes('webpack-dev-server') ||
      messageStr.includes('Hot Module Replacement') ||
      messageStr.includes('development server has disconnected') ||
      messageStr.includes('The development server has disconnected') ||
      messageStr.includes('Refresh the page if necessary') ||
      messageStr.includes('vendors~main.chunk.js') ||
      (messageStr.includes('main.chunk.js') && messageStr.includes('HMR')) ||
      (messageStr.includes('chunk.js') && (messageStr.includes('HMR') || messageStr.includes('WDS'))) ||
      // More specific patterns for stubborn HMR logs
      messageStr.match(/^\[HMR\]\s*Waiting for update signal from WDS/i) ||
      messageStr.match(/log\.js:\d+:\d+$/i)
    );
  };

  console.warn = (...args) => {
    if (shouldSuppressMessage(args)) {
      return;
    }
    originalWarn.apply(console, args);
  };

  console.log = (...args) => {
    if (shouldSuppressMessage(args)) {
      return;
    }
    originalLog.apply(console, args);
  };

  console.info = (...args) => {
    if (shouldSuppressMessage(args)) {
      return;
    }
    originalInfo.apply(console, args);
  };

  // Only suppress specific development-related errors, not all errors
  console.error = (...args) => {
    const message = args.join(' ');
    if (
      message.includes('development server has disconnected') ||
      message.includes('The development server has disconnected')
    ) {
      return;
    }
    originalError.apply(console, args);
  };
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
